import Vue from 'vue'
import Router from 'vue-router'
import OKTALoginPage from '@/views/login/OKTALoginPage'
import OldSm from '@/views/workbench/SM'
import OldAd from '@/views/workbench/AD'
import WorkbenchConvergence from '@/views/workbenchConvergence/WorkbenchConvergence'
import DevPage from '@/views/devPage/devPage'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'
import QuickSightDashboard from '@/appComponents/chartDashboard/QuickSightDashboard'

import {
  AudienceHub,
} from '@/views/audienceHub'

import AudienceHubDashboard from '@/views/audienceHub/AudienceHubDashboard'

import UsersView from '@/views/permissions/UsersView'
import AdminLogin from '@/views/permissions/AdminLogin'
import AdminView from '@/views/permissions/AdminView'
import PermissionsView from '@/views/permissions/PermissionsView'

import {TARGET_CONSTANTS as TC} from '@/helpers/targets'

const OKTA_ISSUER_URL = process.env.OKTA_ISSUER_URL
const OKTA_CLIENT_ID = process.env.OKTA_CLIENT_ID

const oktaAuth = new OktaAuth({
  issuer: OKTA_ISSUER_URL,
  clientId: OKTA_CLIENT_ID,
  redirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email'],
  tokenManager: {
    autoRenew: true,
    expireEarlySeconds: 5 * 60  // the token will be reset every 55 minutes
  }
})

Vue.use(Router)
Vue.use(OktaVue, { oktaAuth })

const ROUTES = {
  PERMISSIONS: {
    path: 'permissions',
    name: 'Permissions'
  },
  USERS: {
    path: 'users',
    name: 'Users'
  },
  ADMIN: {
    path: '/admin',
    name: 'Admin'
  }
}

const router = new Router({
  routes: [
    {
      path: '/logout',
      name: 'LOGOUT',
      component: AudienceHub,
    },
    {
      path: '/',
      name: 'Default',
      component: AudienceHub,
    },
    {
      path: '/login',
      name: 'login',
      component: OKTALoginPage,
    },
    {
      path: '/workbench/sm/:id',
      name: TC.sd.workbench,
      component: OldSm,
    },
    {
      path: '/workbench/ad/:id',
      name: TC.ad.workbench,
      component: OldAd,
    },
    {
      path: '/aw/:id',
      name: 'NewWorkbench',
      component: WorkbenchConvergence,
    },
    {
      path: '/newworkbench/adstra/:id',
      name: 'XandrWorkbench',
      component: WorkbenchConvergence,
    },
    {
      path: '/audience-hub/',
      name: 'audience-hub',
      component: AudienceHub,
      children: [
        {
          path: 'targets/:name?',
          name: 'user-audience-hub',
          component: AudienceHubDashboard,
          props: route => ({ query: route.query }),
        },
      ],
    },
    {
      path: '/admin',
      name: 'Admin',
      component: AdminView,
      children: [
        {
          path: 'permissions',
          name: 'Permissions',
          component: PermissionsView,
        },
        {
          path: 'users',
          name: 'Users',
          component: UsersView,
        },
      ],
    },
    {
      path: '/admin/idmlogin',
      name: 'AdminLogin',
      component: AdminLogin,
    },
    {
      path: '/dev/workingpage',
      component: DevPage,
    },
    {
      path: '/quicksight-dashboard',
      component: QuickSightDashboard,
    },
  ],
})

export default router
export {ROUTES}



// WEBPACK FOOTER //
// ./src/app/router/index.js